import {MatPaginatorIntl} from '@angular/material/paginator';

export function getSpanishPaginator() {
  const paginatorIntl = new MatPaginatorIntl();
  paginatorIntl.itemsPerPageLabel = 'Cantidad por página:';
  paginatorIntl.nextPageLabel = 'Página siguiente';
  paginatorIntl.previousPageLabel = 'Pagina anterior';
  return paginatorIntl;
}
